(() => {
  if (customElements.get('lc-aplique-v2')) return;
  class LCAplique extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-show-media]');
        if (link) {
          event.preventDefault();
          this.querySelectorAll('[data-media-id]').forEach(item => {
            item.hidden = item.dataset.mediaId !== link.dataset.showMedia;
            if (item.hidden) item.querySelectorAll('video').forEach(video => video.pause());
          });
          this.querySelectorAll('[data-show-media]').forEach(item => {
            if (item === link) item.setAttribute('aria-current', 'true');
            else item.removeAttribute('aria-current');
          });
        }
        const zoom = event.target.closest('[data-zoom]');
        if (zoom) {
          const image = this.dialog.querySelector('[data-dialog-image]');
          image.src = zoom.dataset.zoom;
          image.alt = zoom.parentElement.querySelector('img')?.alt || '';
          this.dialog.showModal();
        }
        if (event.target.closest('[data-close-dialog]') || event.target === this.dialog) this.dialog.close();
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.dialog?.close();
    }
  }
  customElements.define('lc-aplique-v2', LCAplique);
})();
